import { render, staticRenderFns } from "./SettingsRecipesGroups.vue?vue&type=template&id=248b52b1"
import script from "./SettingsRecipesGroups.vue?vue&type=script&lang=js"
export * from "./SettingsRecipesGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports